import React, { useEffect } from "react";
import { Form, Row, Col, Select, InputNumber, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const yesNoLOV = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export default function LimitsEligibilityRulesForm({
  form,
  initialValues,
  onFinish,
  currencyOptions,
}) {
  useEffect(() => {
    if (initialValues) form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <>
      <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
        Limits & Eligibility Rules
      </h3>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row gutter={24}>
          {/* Counterparty Limit Required */}
          <Col span={12}>
            <Form.Item
              name="counterpartyLimitRequired"
              label={
                <span>
                  Counterparty Limit Required
                  <Tooltip title="Enforces counterparty exposure validation at deal booking.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              rules={[{ required: true }]}
            >
              <Select
                options={yesNoLOV}
                placeholder="Yes / No"
                style={{ height: 44 }}
              />
            </Form.Item>
          </Col>

          {/* Portfolio Limit Required */}
          <Col span={12}>
            <Form.Item
              name="portfolioLimitRequired"
              label={
                <span>
                  Portfolio Limit Required
                  <Tooltip title="Enforces concentration and portfolio exposure limits.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              rules={[{ required: true }]}
            >
              <Select
                options={yesNoLOV}
                placeholder="Yes / No"
                style={{ height: 44 }}
              />
            </Form.Item>
          </Col>

          {/* Deal Size Min */}
          <Col span={12}>
            <Form.Item
              name="dealSizeMin"
              label="Minimum Deal Size"
              rules={[{ required: true }]}
            >
              <InputNumber
                style={{ width: "100%", height: 44 }}
                placeholder="Enter minimum deal size"
                min={0}
                formatter={(value) =>
                  value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/,/g, "")}
              />
            </Form.Item>
          </Col>

          {/* Deal Size Max */}
          <Col span={12}>
            <Form.Item
              name="dealSizeMax"
              label="Maximum Deal Size"
              rules={[{ required: true }]}
            >
              <InputNumber
                style={{ width: "100%", height: 44 }}
                placeholder="Enter maximum deal size"
                min={0}
                formatter={(value) =>
                  value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/,/g, "")}
              />
            </Form.Item>
          </Col>

          {/* Currency Restriction */}
          <Col span={12}>
            <Form.Item
              name="currencyRestriction"
              label={
                <span>
                  Currency
                  <Tooltip title="Restricts deals to allowed currencies.">
                    <InfoCircleOutlined
                      style={{ marginLeft: 4, color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              // rules={[{ required: true }]}
            >
              <Select
                options={currencyOptions}
                placeholder="Select allowed currency / currencies"
                onChange={(value, option) => {
                  // 👇 store currency code silently
                  console.log(option);
                  form.setFieldsValue({
                    currencyCode: option.code,
                  });
                }}
                style={{ height: 44 }}
              />
            </Form.Item>
          </Col>

          {/* REQUIRED hidden field */}
          <Form.Item name="currencyCode" hidden>
            <InputNumber />
          </Form.Item>
        </Row>

        <button type="submit" hidden />
      </Form>
    </>
  );
}
